import { FBConversionPUSH } from "../utilities/axioscall";
import { fbevent } from "@/lib/fpixel";
import { generateEventID } from "@/utilities/axioscall";

export const FBPIXPush = (
  EVENT_ENUM,
  cartinfoData,
  order_id = "",
  order_object = null
) => {
  if (!EVENT_ENUM) {
    console.error("FBPIXPush: Missing EVENT_ENUM or cartinfoData");
    return;
  }

  const content_ids =
    cartinfoData?.products?.map((product) => product.esin) || [];

  // Generate a unique event ID
  const univ_eventid = order_id ? `purchase_${order_id}` : generateEventID();

  // Call backend conversion push only for non-purchase events
  if (!order_id) {
    FBConversionPUSH(EVENT_ENUM, "", univ_eventid);
  }

  // Define payload for fbevent
  const payload = order_object || {
    content_ids,
    content_type: "product",
  };

  // Trigger the Facebook event
  fbevent(EVENT_ENUM.name, payload, univ_eventid);
};
